import React from "react";
import { isEmpty } from "lodash";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { AiOutlineEye } from "react-icons/ai";
import { BsArrowUpShort } from "react-icons/bs";
import dayjs from "dayjs";
import TableHeaderCell from "components/reusable/TableHeaderCell";

const Table = ({ inquiries, paginationObj, sort, setSort }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const toggleDateSort = () => {
    if (sort.sortBy === "createdAt" && sort.sortType === "asc") {
      setSort({ sortBy: "createdAt", sortType: "desc" });
    } else {
      setSort({ sortBy: "createdAt", sortType: "asc" });
    }
  };

  return (
    <div className="p-3">
      <div className="overflow-x-auto relative rounded-lg border">
        <table className="w-full text-xs text-left text-[#6c6c6c] dark:text-gray-400">
          <thead className="text-xs text-gray-900 border border-[#E1E6EE] bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400">
            <tr>
              <TableHeaderCell text={t("SR_NO")} />
              <TableHeaderCell text="Name" />
              {/* <TableHeaderCell text="Organization" /> */}
              <TableHeaderCell text="Email" />
              <TableHeaderCell text="Phone" />
              {/* <TableHeaderCell text="Partnership type" /> */}
              <th scope="col" className="py-3 px-6 cursor-pointer" onClick={toggleDateSort}>
                <div className="flex">
                  <span>{t("CREATED_DATE")}</span>
                  <span>
                    {sort.sortBy === "createdAt" && sort.sortType === "asc" && <BsArrowUpShort className="w-4 h-4" />}
                    {sort.sortBy === "createdAt" && sort.sortType === "desc" && <BsArrowUpShort className="w-4 h-4 rotate-180" />}
                  </span>
                </div>
              </th>
              <th scope="col" className="py-3 px-6 text-center">
                {t("O_STATUS")}
              </th>
              <th scope="col" className="py-3 px-6 text-center">
                {t("O_ACTION")}
              </th>
            </tr>
          </thead>
          <tbody>
            {inquiries?.map((item, i) => (
              <tr key={item._id} className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                <th scope="row" className="py-4 px-6 border-r font-medium text-gray-900 dark:text-white">
                  {i + 1 + 10 * ((paginationObj?.page || 1) - 1)}
                </th>
                <td className="py-4 px-6 border-r text-gray-900">{item?.name || "-"}</td>
                {/* <td className="py-4 px-6 border-r text-gray-900">{item?.organization || "-"}</td> */}
                <td className="py-4 px-6 border-r text-gray-900">{item?.email || "-"}</td>
                <td className="py-4 px-6 border-r text-gray-900">{item?.phone || "-"}</td>
                {/* <td className="py-4 px-6 border-r text-gray-900">{item?.partnershipTypes?.join(", ") || "-"}</td> */}
                <td className="py-4 px-6 border-r text-gray-900">{dayjs(item?.createdAt).format("MM-DD-YYYY hh:mm A")}</td>
                <td className="py-4 px-6 border-r text-center">
                  <span
                    className={`px-2 py-1 rounded text-xs ${
                      item?.status === "viewed" ? "bg-gray-200 text-gray-700" : "bg-blue-100 text-blue-700"
                    }`}
                  >
                    {item?.status === "viewed" ? "Viewed" : "New"}
                  </span>
                </td>
                <td className="py-4 px-6 border-l text-gray-900">
                  <div className="flex justify-center">
                    <button
                      title={t("VIEW_PARTNER_INQUIRY")}
                      onClick={() => navigate(`/static-page-management/partner-inquiries/view/${item._id}`)}
                    >
                      <AiOutlineEye className="w-5 h-5 text-slate-600" />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
            {isEmpty(inquiries) && (
              <tr className="bg-white text-center border-b dark:bg-gray-800 dark:border-gray-700">
                <td className="py-4 px-6 border-r" colSpan={9}>
                  {t("O_NO_RECORD_FOUND")}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Table;
